import type {CopilotChatModel} from '@github-ui/copilot-chat-types'

export const AUTO_MODEL_ID = 'auto'

// Canonical Auto explainer. Exported so consumers (e.g. the model info popover)
// can fall back to it when an Auto entry sourced from CAPI arrives without a
// description — CAPI may omit one and the generic capabilities fallback has no
// rule for Auto, leaving it undefined.
export const AUTO_MODEL_DESCRIPTION =
  'Auto selects the best model for each request based on its complexity and real-time model availability.'

/**
 * Singleton Auto model pseudo-entry. Returns the same object reference every
 * call so hooks like useDefaultModel don't trigger re-renders.
 *
 * Most capability fields just satisfy the CopilotChatModel TypeScript interface —
 * they aren't consumed by UI logic for the Auto entry since CAPI handles routing.
 */
const AUTO_MODEL: CopilotChatModel = {
  id: AUTO_MODEL_ID,
  name: 'Auto',
  displayName: 'Auto',
  description: AUTO_MODEL_DESCRIPTION,
  version: AUTO_MODEL_ID,
  vendor: 'GitHub',
  preview: false,
  // eslint-disable-next-line camelcase
  model_picker_enabled: true,
  hasLimitedCapabilities: false,
  isThirdParty: false,
  capabilities: {
    family: AUTO_MODEL_ID,
    limits: {
      // eslint-disable-next-line camelcase
      max_prompt_tokens: 128000,
      vision: {
        // eslint-disable-next-line camelcase
        supported_media_types: ['image/jpeg', 'image/png', 'image/webp', 'image/gif'],
      },
    },
    supports: {
      // eslint-disable-next-line camelcase
      tool_calls: true,
      streaming: true,
      vision: true,
    },
    tokenizer: 'o200k_base',
    type: 'chat',
  },
  billing: {
    // eslint-disable-next-line camelcase
    is_premium: false,
    multiplier: 0,
  },
}

export function getAutoModel(): CopilotChatModel {
  return AUTO_MODEL
}
